import type { ConfluenceHeaderImageGenerationResponse } from '@atlassian/convo-ai-api';

export type AIHeaderImageStatus =
	| 'NOT_LOADING'
	| 'LOADING'
	| 'LOADING_WITH_ACCEPTANCE_FLOW'
	| 'SUCCESSFULLY_SET'
	| 'ERROR';

/**
 * Available theme values for AI header image generation
 */
export const IMAGE_GENERATION_THEMES = {
	ATLASSIAN_V4: 'atlassian_v4',
	ATLASSIAN_EXPLORE: 'atlassian_explore',
	ATLASSIAN_BUILD: 'atlassian_build',
} as const;

export type ImageGenerationTheme =
	(typeof IMAGE_GENERATION_THEMES)[keyof typeof IMAGE_GENERATION_THEMES];

export type GenerateImageProps = {
	adfContent: string;
	showAcceptanceFlow?: boolean;
	useRawPrompt?: boolean;
	theme?: ImageGenerationTheme;
};

export type GenerateImageEventCallbacks = {
	onGenerateStart?: (params: { contentId: string; useRawPrompt: boolean; theme?: string }) => void;
	onGenerateSuccess?: (params: {
		contentId: string;
		useRawPrompt: boolean;
		theme?: string;
	}) => void;
	onGenerateError?: (params: {
		contentId: string;
		useRawPrompt: boolean;
		theme?: string;
		error: Error;
	}) => void;
	onGenerateAbort?: (params: { contentId: string; useRawPrompt: boolean; theme?: string }) => void;
};

export type UseAIGeneratedCoverImageProps = {
	contentId: string;
	/**
	 * Optional callbacks for tracking image generation events (e.g., experience tracking)
	 */
	eventCallbacks?: GenerateImageEventCallbacks;
};

export type UseAIGeneratedCoverImageReturn = {
	aiHeaderImageFileId?: string;
	aiHeaderImageStatus?: AIHeaderImageStatus;
	data: ConfluenceHeaderImageGenerationResponse | null;
	error: string | null;
	fakeGenerateImage: () => void;
	generateImage: (props: GenerateImageProps) => Promise<void>;
	loading: boolean;
	setAIHeaderImageStatus: (status: AIHeaderImageStatus) => void;
};
